import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'
const equipRouter: RouteConfig = {
  path: '/expertTank',
  redirect: 'noredirect',
  name: 'expertTank',
  component: Layout,
  children: [
    {
      path: 'expertTank',
      component: () => import('@/views/expertTank/index.vue'),
      name: 'Apparatus',
      meta: {
        title: '专家库',
        icon: 'resource',
        requireAuth: true,
      }
    },
  ]

}

export default equipRouter
